import { Component, Input } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { RouterLink } from "@angular/router";
import { IndividualRelationshipGroupModel } from "../../models/individual-relationship-group-model";
import { RelationshipIndividualDto } from "@models/individuals/relationship-individual-dto";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { EntityType } from "@models/common/entity-type.enum";
import { ACNPipe } from "../../../../../../shared/pipes/acnPipe";
import { ABNPipe } from "../../../../../../shared/pipes/abnPipe";
import { getCompanyProfilePath, getTrustProfilePath } from "../../../../../../shared/utils/route-path-utils";

type CellRendererParams = ICellRendererParams<RelationshipIndividualDto | IndividualRelationshipGroupModel>;

@Component({
  selector: 'app-ag-individual-entity-name',
  standalone: true,
  imports: [RouterLink],
  templateUrl: 'ag-individual-entity-name.component.html',
  styleUrl: 'ag-individual-entity-name.component.scss'
})
export class AgIndividualEntityNameComponent implements ICellRendererAngularComp {
  @Input() entityNumberName = '';
  @Input() entityNumber = '';
  @Input() entityName = '';
  @Input() link: string[] | null = null;

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.entityName = params.data?.entityName ?? '';
    this.entityNumber = params.data?.relatedToEntityType == EntityType.Company
      ? ACNPipe.formatValue(params.data?.entityNumber)
      : ABNPipe.formatValue(params.data?.entityNumber);
    this.entityNumberName = params.data?.relatedToEntityType == EntityType.Company
      ? 'ACN: '
      : 'ABN: ';

    this.link = params.data?.relatedToEntityType == EntityType.Company
      ? getCompanyProfilePath(params.data?.entityId ?? '')
      : getTrustProfilePath(params.data?.entityId ?? '');


    return true;
  }

}
